import React, { useState } from "react";
import { Copy, CheckCircle2 } from "lucide-react";

/**
 * Small clipboard button used across admin setup cards to expose stable
 * strings (redirect URIs, webhook URLs). Copies on click with a 1.5s
 * "copied" affordance.
 */
export const CopyField: React.FC<{ value: string; testId?: string }> = ({ value, testId }) => {
  const [copied, setCopied] = useState(false);
  const doCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={doCopy}
      className="w-full text-left flex items-center gap-2 font-mono text-xs bg-[color:var(--sg-muted-bg)] hover:bg-slate-200 transition-colors px-3 py-2 rounded border border-[color:var(--sg-border)]"
    >
      <span className="truncate flex-1">{value}</span>
      {copied ? (
        <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600 shrink-0" />
      ) : (
        <Copy className="h-3.5 w-3.5 text-[color:var(--sg-muted)] shrink-0" />
      )}
    </button>
  );
};
